export default function Footer() {
  return (
    <>
<div className="footer">
    <div>
    © 2024 Brianne Camesi. All rights reserved.
    </div>
</div>
    </>
  )
}